import React from "react";
import { createPortal } from "react-dom";

function LoadingModal({
  isOpen,
  title = "Processing Your Request",
  message = "This will only take a moment. Thank you for your patience.",
  showWarning = true,
  warningText = "Please do not refresh this page or use the back button while your request is being processed.",
}) {
  if (!isOpen) return null;

  const modalContent = (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[9999] transition-opacity duration-300"
        aria-hidden="true"
      />

      {/* Modal Container */}
      <div
        className="fixed inset-0 z-[10000] flex items-center justify-center p-4 sm:p-6 md:p-8"
        role="dialog"
        aria-modal="true"
        aria-labelledby="loading-modal-title"
      >
        <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full p-6 sm:p-8 md:p-12 mx-4 transform transition-all duration-300">
          {/* Spinner */}
          <div className="flex justify-center mb-6">
            <div className="relative">
              <div className="w-16 h-16 sm:w-20 sm:h-20 border-4 border-gray-200 rounded-full"></div>
              <div className="w-16 h-16 sm:w-20 sm:h-20 border-4 border-orange-500 rounded-full border-t-transparent animate-spin absolute top-0 left-0"></div>
            </div>
          </div>

          {/* Title */}
          <h2
            id="loading-modal-title"
            className="text-xl sm:text-2xl font-semibold text-gray-900 text-center mb-3"
          >
            {title}
          </h2>

          {/* Message */}
          <p className="text-gray-600 text-center text-sm sm:text-base mb-6">
            {message}
          </p>

          {/* Warning Section */}
          {showWarning && (
            <div className="bg-orange-50 border-l-4 border-orange-500 p-3 sm:p-4 rounded text-left">
              <div className="flex items-start">
                <div className="flex-shrink-0">
                  <svg
                    className="h-5 w-5 text-orange-500 mt-0.5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-xs sm:text-sm text-orange-800">
                    <span className="font-semibold">Important:</span>{" "}
                    {warningText}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );

  return createPortal(modalContent, document.body);
}

export default LoadingModal;
